import { SHORTCUTS } from "../keyboard";
import { Dialog } from "./Dialog";
import { Button, Kbd } from "./primitives";

/** Renders the same list the keyboard model is defined from, so the two cannot drift apart. */
export function KeyboardHelp({ open, onClose }: { open: boolean; onClose: () => void }) {
  return (
    <Dialog
      open={open}
      title="Tangentbord"
      subtitle="Genvägar"
      onClose={onClose}
      footer={
        <Button variant="primary" onClick={onClose}>
          Stäng
        </Button>
      }
    >
      <dl className="grid gap-s4">
        {SHORTCUTS.map((shortcut) => (
          <div key={shortcut.keys} className="flex items-center justify-between gap-s6">
            <dt className="text-body text-ink">{shortcut.description}</dt>
            <dd>
              <Kbd>{shortcut.keys}</Kbd>
            </dd>
          </div>
        ))}
      </dl>
    </Dialog>
  );
}
